module.exports = __webpack_public_path__ + "img/brand--oeshle.4ee9d626.png";